var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVersionsDark2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "versions_dark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_46267",
    "data-name": "Path 46267",
    d: "M0,0H18V18H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46268",
    "data-name": "Path 46268",
    d: "M9.383,12.883a.626.626,0,0,1-.79,0L4.646,9.7a.617.617,0,0,0-.783,0,.681.681,0,0,0,0,1.047L8.2,14.25a1.253,1.253,0,0,0,1.579,0l4.339-3.508a.681.681,0,0,0,0-1.047l-.006-.007a.617.617,0,0,0-.783,0L9.383,12.883Zm.4-2.014,4.339-3.508a.688.688,0,0,0,0-1.054L9.788,2.8a1.253,1.253,0,0,0-1.579,0L3.869,6.314a.688.688,0,0,0,0,1.054l4.339,3.508a1.244,1.244,0,0,0,1.579-.007Z",
    transform: "translate(0 0)",
    fill: "#92a1b6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersionsDark2);
export default __webpack_public_path__ + "static/media/versions_dark2.9d860ec3aec7da514b5c491119da875b.svg";
export { ForwardRef as ReactComponent };